/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/common/material/material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxListItemComponent } from './checkbox-list-item.component';
import { CheckboxListComponent } from './checkbox-list.component';
import { CheckboxSetComponent } from './checkbox-set.component';
import { CustomCheckboxContentDirective } from './custom-checkbox-content.directive';

@NgModule({
	declarations: [
		CheckboxListComponent,
		CheckboxListItemComponent,
		CheckboxSetComponent,
		CustomCheckboxContentDirective,
	],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
	providers: [],
	exports: [
		CheckboxListComponent,
		CheckboxListItemComponent,
		CheckboxSetComponent,
		CustomCheckboxContentDirective,
	],
})
export class CheckboxListModule {}
